module.exports = __webpack_public_path__ + "static/media/beet-harvester.dd52f0d5.svg";